app.factory('navService', [function () {
	var service = this;

	service.shown = false;

	// Desktop media query listener.
	service.showButtons = false;
	service.mediaQuery = window.matchMedia("only screen and (min-width: 768px)");
	service.mediaQuery.addListener(function(mediaQuery) {
		service.showButtons = !mediaQuery.matches;
	});
	service.showButtons = !service.mediaQuery.matches;

	service.toggle = function() {
		service.shown = !service.shown;
	}

	service.open = function() {
		service.shown = true;
	}

	service.close = function() {
		service.shown = false;
	}

	return service;
}]);